<template>
	<div class="wrap">
		<div class="wrapLeft">
			<div class="content-html" v-resize="resize">
				<quill-editor ref="myQuillEditor" v-model="transHtml" :style="'height:' + height"
					:options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
					@ready="onEditorReady($event)" @change="onEditorChange($event)" />
			</div>
		</div>
		<div class="wrapRight">
			<el-form ref="form" :model="form" label-width="80px" :rules="rules">
				<el-form-item label="标题" prop="docTitle">
					<el-input v-model="form.docTitle" placeholder="请输入标题" clearable required></el-input>
				</el-form-item>
				<el-form-item label="首图">
					<el-upload class="avatar-uploader" action="#" :show-file-list="false"
						:http-request="uploadHttpRequest">
						<div class="el-upload">
							<img v-if="form.docImg" :src="form.docImg" class="firstImg">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</div>
					</el-upload>
				</el-form-item>
				<el-form-item label="简介">
					<el-input v-model="form.docIntroduction" placeholder="请输入简介" clearable></el-input>
				</el-form-item>
				<el-form-item label="标签">
					<el-input v-model="form.docTags" placeholder="请输入标签,每个标签用','隔开" clearable></el-input>
				</el-form-item>
				<el-form-item label="文章来源" prop="sourceUrl">
					<el-input v-model="form.sourceUrl" placeholder="请输入文章标签" clearable required></el-input>
				</el-form-item>
				<el-form-item label="作者" prop="author">
					<el-input v-model="form.author" placeholder="请输入作者" clearable required></el-input>
				</el-form-item>
				<el-form-item label="文章语言">
					<el-radio-group v-model="form.language">
						<el-radio label="zh">中文</el-radio>
						<el-radio label="en">英文</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="创建单位" prop="createUnit">
					<el-input v-model="form.createUnit" placeholder="请输入创建单位" clearable required></el-input>
				</el-form-item>
				<el-form-item label="文章时间" prop="startTime">
					<el-date-picker v-model="form.startTime" type="datetime" placeholder="选择日期时间"
						value-format="yyyy-MM-dd HH:mm:ss" clearable required>
					</el-date-picker>
				</el-form-item>
				<el-form-item>
					<div class="bottom-button">
						<el-button type="primary" @click="goUploadDocCollect"> 录入文章</el-button>
					</div>
				</el-form-item>

			</el-form>
		</div>
	</div>

</template>

<script>
	import {
		Base64
	} from 'js-base64'
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";
	import turndown from "turndown"; //html转markdown
	// html显示（富文本插件）
	import {
		quillEditor
	} from "vue-quill-editor";
	import {
		detailNoNav,
		ywDetails,
		navList,
		soldOutList,
		sortSave,
		updateDoc,
		uploadDocImg,
		uploadDocCollect
	} from "@/network/mochaItom/index.js"
	const toolbarOptions = [
	    ['bold', 'italic', 'underline', 'strike'],
	    ['blockquote', 'code-block'],
	    [{'header': 1}, {'header': 2}],
	    [{'list': 'ordered'}, {'list': 'bullet'}],
	    [{'script': 'sub'}, {'script': 'super'}],
	    [{'indent': '-1'}, {'indent': '+1'}],
	    [{'direction': 'rtl'}],
	    [{'size': ['small', false, 'large', 'huge']}],
	    [{'header': [1, 2, 3, 4, 5, 6, false]}],
	    [{'color': []}, {'background': []}],
	    [{'font': []}],
	    [{'align': []}],
	    ['clean'],
	    ['link', 'image', 'video']
	];
	export default {
		components: {
			quillEditor,
		},
		data() {
			return {
				height: '',
				editorOption: {
					placeholder: "编辑文章内容",
					modules: {
						toolbar: {
							container: toolbarOptions, // 工具栏
							handlers: {
								'image': (value) => {
									if (value) {
										// 触发input框选择图片文件
										this.imgType = 2;
										document.querySelector('.avatar-uploader input').click()
									} else {
										this.quill.format('image', false);
									}
								}
							}
						}
					}
				},
				transHtml: "",
				docImg:"",//上传图片地址
				form: {
					docTitle: "",
					docImg: "",
					docIntroduction: "",
					docTags: "",
					sourceUrl: "",
					language: "en",
					author: "",
					createUnit: "",
					startTime: "",
				},
				rules: {
					docTitle: [{
						required: true,
						message: '请输入文章标题',
						trigger: 'blur'
					}],
					author: [{
						required: true,
						message: '请输入文章作者',
						trigger: 'blur'
					}],
					createUnit: [{
						required: true,
						message: '请输入创建单位',
						trigger: 'blur'
					}],
					sourceUrl: [{
						required: true,
						message: '请输入文章来源',
						trigger: 'blur'
					}],
					startTime: [{
						required: true,
						message: '请选择日期',
						trigger: 'blur'
					}],
				},
				operFormArr: [
				  {
				    name: "roleName",
				    label: "角色名称",
				    defaultText: "请输入角色名称",
				  },
				  {
				    name: "role",
				    label: "英文名称",
				    defaultText: "请输入英文名称",
				  },
				],
				imgType: 1, //1首图，2文章内部的图
				turndownService: null,
			}
		},
		directives: { // 使用局部注册指令的方式
			resize: { // 指令的名称
				bind(el, binding) { // el为绑定的元素，binding为绑定给指令的对象
					let width = '',
						height = '';

					function isReize() {
						const style = document.defaultView.getComputedStyle(el);
						// console.log(style)
						if (width !== style.width || height !== style.height) {
							binding.value(style.height); // 关键
						}
						width = style.width;
						height = style.height;
					}
					el.__vueSetInterval__ = setInterval(isReize, 300);
				},
				unbind(el) {
					clearInterval(el.__vueSetInterval__);
				}
			}
		},
		created() {
			// html 转换 markdown 
			const TurndownService = require("turndown").default;
			this.turndownService = new TurndownService();
		},
		methods: {
			uploadHttpRequest(param) { //上传图片
				const formData = new FormData();
				formData.append('file', param.file);
				formData.append('type', this.imgType);
				uploadDocImg(formData).then(res => {
					if (res.data.code == 200) {
						if (this.imgType == 1) { //文章首图
							this.docImg = res.data.data;
							this.form.docImg = URL.createObjectURL(param.file);
						} else {
							let quill = this.$refs.myQuillEditor.quill;
							let length = quill.getSelection().index;
							// 插入图片  
							quill.insertEmbed(length, 'image', res.data.data);
							// 调整光标到最后
							quill.setSelection(length + 1);
							console.log()
						}
					}
					this.imgType = 1;
				})
			},
			goUploadDocCollect() { //录入文章
				if (this.transHtml == '') {
					this.$message.success('文章内容不能为空');
					return
				}
				this.form.docImg = this.docImg;
				this.$refs['form'].validate((valid) => {
					if (valid) {
						let markdown = this.turndownService.turndown(this.transHtml);
						let transHtmlStart =
							'<!DOCTYPE html><html><head><meta charset="utf-8" /><meta name="viewport" content="width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no" /></head><body>';
						let transHtmlEnd = '</body></html>'
						this.transHtml = transHtmlStart + this.transHtml + transHtmlEnd;
						uploadDocCollect({
							"docType": "md", //展示类型默认
							"html": Base64.encode(this.transHtml),
							"md": Base64.encode(markdown),
							...this.form
						}).then(res => {
							if (res.data.code == 200) {
								this.$message.success('录入成功');
							}

						})
					} else {
						return false
					}
				}); //表单验证
			},
			// 编辑器
			resize(data) { // 当宽高变化时就会执行
				//执行某些操作
				let height = data.slice(0, data.length - 2) - 100 + "px"
				this.height = height;
			},
			// 编辑器的方法
			onEditorReady(quill) {
				console.log("editor ready!");
			},
			onEditorFocus(quill) {
				console.log("editor focus!");
			},
			onEditorChange({
				quill,
				html,
				text
			}) {
				// console.log('editor change!', quill, html, text);
				this.transHtml = html;
			},
			onEditorBlur(quill) {
				console.log("editor blur!", quill);
			},
		}
	}
</script>
<style scoped="scoped" lang="scss">
	.wrap {
		display: flex;
		flex-direction: row !important;
		height: 100%;

		>div {
			box-sizing: border-box;
			padding: 20PX;
		}

		.wrapLeft {
			width: 900px;
			height: 100%;
			display: flex;
			background-color: #ffffff;
			border: 1px solid #eee;
			overflow-y: auto;
			overflow-x: hidden;
			flex-direction: column;

			/deep/ div,
			/deep/ p {
				width: 100% !important;
			}

			/deep/img {
				width: 860px;
				margin: 20px 0;
			}

			.content-html {
				flex: 1;
				display: flex;
			}

			.bottom-button {
				height: 100PX;
				width: 100%;
				display: flex;
				align-items: center;
			}
		}

		.wrapRight {
			flex: 1;
			background-color: #ffffff;

			.firstImg {
				width: 100%;
				max-height: 500px;
			}

			.avatar-uploader .el-upload {
				border: 1px dashed #d9d9d9;
				border-radius: 6px;
				cursor: pointer;
				position: relative;
				overflow: hidden;
			}

			.avatar-uploader .el-upload:hover {
				border-color: #409EFF;
			}

			.avatar-uploader-icon {
				font-size: 28px;
				color: #8c939d;
				width: 178px;
				height: 178px;
				line-height: 178px;
				text-align: center;
			}

			.avatar {
				width: 178px;
				height: 178px;
				display: block;
			}
		}
	}
</style>
